import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const shipTypeApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.optional(v.string()),
  id: v.number(),
  lookupCodeType: v.string(),
});

export const shipTypeSchema = v.object({
  ...shipTypeApiSchema.entries,
  ...optionSchema.entries,
});

export const shipTypesApiSchema = paginatedSchema(shipTypeApiSchema);

export type ShipTypeApi = v.InferOutput<typeof shipTypeApiSchema>;
export type ShipTypesApi = v.InferOutput<typeof shipTypesApiSchema>;

export type ShipTypeFilters = Filters<ShipTypeApi>;

export type ShipTypeFiltersUpdateApi = FiltersUpdateApi<ShipTypeApi>;

export type ShipType = Prettify<Option<v.InferOutput<typeof shipTypeSchema>>>;

export type ShipTypes = Entities<ShipType>;
